<template>
    <a-modal :visible="editorModalVisible" :confirm-loading="confirmLoading" width="580px" @cancel="handleCancel" :footer="null"
                :title="modalData.id ? '编辑KA环境' : '新增KA环境' ">

         <a-form-model :model="modalData" ref="ruleForm" :rules="rules" :layout="formItemLayout"
                :label-col="labelCol" :wrapper-col="wrapperCol">

                <a-form-model-item ref="kadesc" label="KA客户名称" prop="kadesc">
                    <a-input v-model="modalData.kadesc" placeholder="KA客户名称" />
                </a-form-model-item>

                <a-form-model-item ref="kacode" label="KA客户编码" prop="kacode">
                    <a-input v-model="modalData.kacode" placeholder="KA客户编码" />
                </a-form-model-item>

                <a-form-model-item ref="kaenv" label="KA客户环境编码" prop="kaenv">
                    <a-input v-model="modalData.kaenv" placeholder="KA客户环境编码" />
                </a-form-model-item>
               
                <a-form-model-item :wrapper-col="{ span: 8, offset: 10 }">
                    <a-button type="primary" @click="handleOk">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>
    </a-modal>
</template>

<script>
export default{
    props:{

    },
    data(){
        return {
            editorModalVisible:false,
            confirmLoading:false,  
            labelCol: { span: 6 },
            wrapperCol: { span:16 },
            formItemLayout:'horizontal',
            modalData:{
                id:'',
                kadesc:'',
                kacode:'',
                kaenv:''
            },
            rules: {
                kacode: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            // var reg = /[^\u4e00-\u9fa5]/;
                            var reg = /[\u4E00-\u9FA5\uF900-\uFA2D]{1,}/;
                            if (value === "") {
                                callback(new Error("请输入KA客户编码"));
                            } else if (reg.test(value)) {
                                callback(new Error("KA客户编码不能为中文"));
                            } else {
                                callback();
                            }
                        }
                    },
                    { min: 1, max: 100, message: '请输入1~100个字符', trigger: 'blur' },
                ],
                kadesc:[
                    { required: true, message: '请输入KA客户名称', trigger: 'blur' },
                ],
                kaenv:[
                    {
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            var reg = /[\u4E00-\u9FA5\uF900-\uFA2D]{1,}/;
                            if (value === "") {
                                callback(new Error("请输入KA客户环境编码"));
                            } else if (reg.test(value)) {
                                callback(new Error("KA客户环境编码不能为中文"));
                            } else {
                                callback();
                            }
                        }
                    },
                    { min: 1, max: 100, message: '请输入1~100个字符', trigger: 'blur' },
                ],
            },
        }
    },
    methods:{
        init(item){
            if(item.id){
                this.modalData.id = item.id;
                this.modalData.kadesc = item.kadesc;
                this.modalData.kacode = item.kacode;
                this.modalData.kaenv = item.kaenv;
            }
            else{
                this.modalData = {
                    id:undefined,
                    kadesc:'',
                    kacode:'',
                    kaenv:''
                }
            }

            this.editorModalVisible = true;
        },
        handleOk() {
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    //处理list
                    if(that.modalData.id){
                        //编辑
                        that.$store.dispatch({
                            type: 'kamanager/updateaccount',
                            params: {
                                ...that.modalData,
                                updateuser:that.G.getCurrentUser().username,
                                urlparams:false,
                            }
                        }).then((res) => {
                            if (res.data.success == '1') {
                                that.handleCancel()
                                this.$emit('onModalHide')
                            }
                       
                        });
                    }
                    else {
                        //新增
                        that.$store.dispatch({
                            type: 'kamanager/addaccount',
                            params: {
                                ...that.modalData,
                                createuser:that.G.getCurrentUser().username,
                                status:JSON.stringify({
                                    svn:false
                                }),
                                urlparams:false,
                            }
                        }).then((res) => {
                            if (res.data.success == 1) {
                                that.handleCancel()
                                this.$emit('onModalHide')
                            }
                       
                        });
                    }
                    console.log(that.modalData)
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleCancel() {
            this.resetForm();
            this.editorModalVisible = false;
            
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    }
}
</script>